@use 'style/utils';

$_CLASS: '.joy-radio-group';

:host {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;

    joy-form-error {
        width: 100%;
        flex-shrink: 0;
        margin-top: var(--joy-core-spacing-3);
    }
}

#{$_CLASS} {
    width: 100%;
}

#{$_CLASS}-container {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    &#{$_CLASS}-horizontal {
        flex-direction: row;
        justify-content: flex-start;
    }

    &#{$_CLASS}-vertical {
        flex-direction: column;
        align-items: flex-start;
    }
}

#{$_CLASS}-fieldset {
    border: 0;
    padding: 0;
    margin: 0;
}

::slotted(joy-radio:not([type="outline"])) {
    margin: 0 var(--joy-core-spacing-4) var(--joy-core-spacing-4) 0;
}